

const ImageDimensions = [
    {
        height                                : 325,
	
        width                                 : 770,
        

    },


];

export { ImageDimensions };